import React, { Component } from 'react';
import styled from 'styled-components';
import FlipMove from 'react-flip-move';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import WP from 'WP';
import Filters from 'partials/Filters';
import Container from 'partials/Container';
import api from 'api';
import Project from 'partials/Project';
import HeadMeta from 'partials/HeadMeta';
import Loader from 'partials/Loader';
import { isIE } from 'helpers';

import { setCurrentView } from 'store';

class Projects extends Component {

    constructor() {
        super();

        this.state = {
            activeFilters: [WP.trans.all],
            gridType: 2,
            projects: [],
        }
    }

    componentWillMount() {
        this.mounted = true;
        //console.log(this.props.currentView);

        if(!window.location.hash && this.props.currentView && !isIE()) {
            // hash set in <Filters> will trigger routhe change and restarts comp. lifecycle so we can quit here for now (we'll continue once hash is set)
            // NOTE: on IE and Edge changing hash does not trigger lifecycle restart so this DOES not apply for IE/Edge
            return;
        }

        this.props.setCurrentView({
            translation_paths: {
                no: '/'+WP.slugs.projects.no,
                en: '/'+WP.slugs.projects.en
            }
        });

        api.getProjects()
            .then(resp => {
                if(resp.data[0]) {
                    //console.log('PROJECTS: ', resp.data);
                    if(this.mounted) this.setState({ projects: resp.data });
                }
            })
            .catch(e => console.log(e));

        window.addEventListener('resize', this._onResize.bind(this));
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this._onResize.bind(this));
    }

    _onResize() {
        if(window.outerWidth < 980 && this.state.gridType === 4) {
            this.setState({ gridType: 2 });
        } 
    }

    _onFilter(names) {
        this.setState({ activeFilters: names });
    }

    _filtered() {
        const { activeFilters, projects } = this.state;
        if(activeFilters.indexOf(WP.trans.all) !== -1) return projects;

        //if(activeFilters.indexOf(WP.trans.selected) !== -1) {
        //    return projects.filter(project => project.acf.selected);
        //}

        return projects.filter(project => {
            const projectCategories = project.category_info.map(cat => cat.name);
            return activeFilters.some(item => projectCategories.indexOf(item) !== -1);
        });
    }

    _renderProjects() {
        const { gridType } = this.state;

        return this._filtered.bind(this)().map(project => {
            return (
                <Project key={project.id} project={project} gridType={gridType} />
            )
        });
    }

    _onGridToggle(cols) {
        this.setState({ gridType: cols });
    }

    render() {

        return (
            <Wrapper>

                <HeadMeta
                    title={WP.trans.projects+' - HLM'}
                    description=""
                    ogUrl=""
                    ogType=""
                    ogTitle=""
                    ogDescription=""
                    ogImage=""
                />

                <Filters title={WP.trans.projects || 'Prosjekter'} onFilter={this._onFilter.bind(this)} onGridToggle={this._onGridToggle.bind(this)} taxonomy="types" itemsToFilter={this.state.projects} />
                
                <Loader loaded={this.state.projects.length > 0} />

                <GridWrapper>
                    <Container>
                        <Grid 
                            duration={500} 
                            easing="ease-out"
                            enterAnimation={{
                                from: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                                to: {
                                    transform: '',
                                },
                            }}
                            leaveAnimation={{
                                from: {
                                    transform: '',
                                },
                                to: {
                                    transform: 'translateY(100px)',
                                    opacity: 0.1,
                                },
                            }}
                        >
                            {this._renderProjects.bind(this)()}
                        </Grid>
                    </Container>
                </GridWrapper>

            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentView: state.currentView
    }
}

const actions = {
    setCurrentView
}

export default connect(mapStateToProps, actions)(withRouter(Projects));


const Wrapper = styled.div`
    display:block;
    position:relative;
    width:100%;
`

const GridWrapper = styled.div`
    padding-top:30px;
    @media (max-width: 960px) {
        padding-top:0;
    }
`

const Grid = styled(FlipMove)`
    display:flex;
    flex-wrap: wrap;
    margin-left:-20px;
    margin-right:-20px;
    overflow: hidden;
    @media (max-width: 480px) {
        margin-left:-25px;
        margin-right:-25px;
    }
`


// WEBPACK FOOTER //
// ./src/views/Projects.js